var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImages(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.9537 0H2.04746C1.24895 0 0.599609 0.649128 0.599609 1.44858V10.553C0.599609 11.3516 1.24895 12 2.04746 12H11.9537C12.7522 12 13.4009 11.3516 13.4009 10.553V1.44858C13.4009 0.649128 12.7522 0 11.9537 0ZM8.87758 2.15432C9.64978 2.15432 10.276 2.78061 10.276 3.55276C10.276 4.32492 9.64974 4.95121 8.87758 4.95121C8.10516 4.95121 7.47913 4.32492 7.47913 3.55276C7.47913 2.78061 8.10516 2.15432 8.87758 2.15432ZM11.4997 10.6616H7.00013H2.70105C2.31482 10.6616 2.14281 10.3822 2.31692 10.0374L4.71691 5.28383C4.89081 4.93912 5.22223 4.90836 5.45693 5.21505L7.8702 8.36882C8.10491 8.67555 8.51513 8.70165 8.78665 8.42684L9.37702 7.829C9.64832 7.55419 10.048 7.58822 10.2695 7.90451L11.7982 10.0882C12.0192 10.405 11.8859 10.6616 11.4997 10.6616Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImages);
export default __webpack_public_path__ + "static/media/images.1eabd36e96b0a97abbeeeeae1f72727f.svg";
export { ForwardRef as ReactComponent };